module.exports = __webpack_public_path__ + "179dd6c81e1561ab8f0d14fd5ad9dc47.svg";